import { render, staticRenderFns } from "./CapacitorLanguage.vue?vue&type=template&id=6053347d&scoped=true&"
import script from "./CapacitorLanguage.vue?vue&type=script&lang=js&"
export * from "./CapacitorLanguage.vue?vue&type=script&lang=js&"
import style0 from "./CapacitorLanguage.vue?vue&type=style&index=0&id=6053347d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053347d",
  null
  
)

export default component.exports